import './c-box-list.scss';
import template from './box-list.vhtml';

export default {
	template,
	data() {
		return {
			boxEl: [],
		};
	},
	mounted() {
		this.boxEl = this.$children;

		// Add events
		this.boxEl.forEach( el => {
			el.$on( 'selected', uid => {
				this.boxEl.forEach( el => {
					el.$data.isSelected = ( el._uid === uid || el.$data.isSelected === true );
				});
			});
		});

		
	},
	methods: {

	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/box-list/box-list.js